<template>
  <div class="container">
    <!-- 搜索 -->
    <div class="top_search">
      <div class="w1380 top_bg">
        <div class="top-textarea">
          <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" maxlength="1000" show-word-limit placeholder="支持智能语义检索" v-model="searchWord" @keyup.enter.native="toSearch"></el-input>
        </div>
        <el-button type="primary" @click="toSearch">搜索</el-button>
      </div>
    </div>
    <!-- 导航 -->
    <div class="tab">
      <ul>
        <li :class="{ checked: tabIndex == 1 }" @click="handleTab(1)">相似文献</li>
        <li :class="{ checked: tabIndex == 2 }" v-if="listData.length > 0" @click="handleTab(2)">知识图谱</li>
        <!-- <li :class="{ checked: tabIndex == 3 }" @click="handleTab(3)">概念分析</li> -->
      </ul>
    </div>
    <!--  相似文献 主体列表 -->
    <div v-show="tabIndex == 1" class="page1 w1380 flex">
      <div class="left">
        <p class="flex">
          知识点
          <i v-if="!leftFlag && leftData.length > leftNum" class="el-icon-arrow-right" @click="showAllLeftData"></i>
          <i v-if="leftFlag && leftData.length > leftNum" class="el-icon-arrow-down" @click="closeAllLeftData"></i>
        </p>
        <ul v-loading="loading">
          <li v-for="(item, index) in leftFlag ? leftData : leftDataSlice" :key="index" :class="{ checked: entitiesId == item.id }" @click="toList(item)">
            <span class="line1" :title="item.name">{{ item.name }}</span>
            <i>{{ item.paperNum }}</i>
          </li>
        </ul>
      </div>
      <div class="right-list">
        <!-- 检索结果 -->
        <div class="right-top">
          <p class="filter">
            <span class="searchword">
              检索结果：“<label class="red">{{ searchWordResult }}</label
              >”（<label class="red">{{ listData.length }}</label
              >条记录）
            </span>
          </p>
        </div>
        <!-- 检索列表 -->
        <div class="right-item" v-loading="loading">
          <ul>
            <li class="flex" v-for="(item, index) in listData" :key="index">
              <span class="index">{{ index + 1 }}、</span>
              <div class="right-info">
                <p @click="toDetail(item)">
                  <span v-safe-html="item.title"></span>
                </p>
                <p v-if="item.authorArray && item.authorArray.length > 0">
                  作者:
                  <span class="span-content" :class="{ green_span: element.click }" v-for="(element, index) in item.authorArray" :key="index">
                    <span class="span_a" @click="toAuthorDetail(element)" v-safe-html="element.authorName"></span>
                    <span class="mr5" v-if="index < item.authorArray.length - 1">;</span>
                    <div class="author-content">
                      <p class="mb10" v-safe-html="element.authorName"></p>
                      <p>
                        <span v-if="element.hindex != null"
                          >hindex：<label>{{ element.hindex }}</label></span
                        >
                        <span v-if="element.i10Index != null"
                          >i10Index：<label>{{ element.i10Index }}</label></span
                        >
                      </p>
                      <p>
                        <span v-if="element.citedByCount != null"
                          >citedByCount：<label>{{ element.citedByCount }}</label></span
                        >
                        <span v-if="element.worksCount != null"
                          >worksCount：<label>{{ element.worksCount }}</label></span
                        >
                      </p>
                      <p class="hui">{{ element.lastKnownInstitutionName }}</p>
                    </div>
                  </span>
                  <label v-if="item.showauthor && item.authorAllArray.length > 5" class="digestLabel" @click="showauthor(index)">展开</label>
                  <label v-if="!item.showauthor" class="digestLabel" @click="closeauthor(index)">收起</label>
                </p>
                <p v-if="item.journalName">
                  期刊信息:
                  <span @click="toHomeDetail(item)"> <span class="undline" v-safe-html="item.journalName"></span>; </span>
                  <label v-if="item.year">{{ item.year }} ; </label>
                  {{ item.volume }}
                  <label v-if="item.issue && item.issue != 'null'">({{ item.issue }})</label>
                </p>
                <p v-if="item.publishDate">出版时间：<span v-safe-html="item.publishDate"></span></p>
                <p v-if="item.doi">DOI: <span v-safe-html="item.doi"></span></p>
                <p v-if="item.hingeWord">
                  关键词：
                  <span class="fenhao" v-for="(element, idx) in item.hingeWordArray" :key="idx" @click="searchWords(element)">
                    <label class="green" v-safe-html="element"></label>
                    <label v-if="idx < item.hingeWordArray.length - 1">;</label>
                  </span>
                </p>
                <p v-if="item.digest && !item.open">摘要：<span :title="item.digestAll" v-safe-html="capitalize(item.digest)"></span></p>
                <div class="knowledge flex" v-if="item.entities.length > 0">
                  <p>
                    <font>知识点：</font>
                    <span v-for="(element, idx) in item.entities" :key="idx">
                      <el-tooltip :content="element.description" placement="bottom" effect="light" :disabled="element.description ? false : true">
                        <label v-safe-html="element.name"></label>
                      </el-tooltip>
                      <label v-if="idx < item.entities.length - 1">;</label>
                      <!-- <div class="hover_description">{{ element.description }}</div> -->
                    </span>
                  </p>
                  <!-- <span class="more">更多</span> -->
                </div>

                <p v-if="item.source">来源: {{ item.source }}</p>
                <div class="btn-p flex">
                  <p class="num-tips">
                    引用量<span>{{ item.citedCount }}</span>
                  </p>
                  <div class="btn-right">
                    <div @click.stop class="flex">
                      <div class="btn" v-if="roles && item.gainLiteratureState === true && item.source !== '商业资源'" @click="getResource(item, index)" :class="{ noCourse: item.btnLoading }">
                        <img class="rotating-image" v-if="item.btnLoading" src="../../assets/images/loading_s.svg" />
                        <img class="img" src="../../assets/images/icon-qwhq-mr.png" />
                        <img class="hover-img" src="../../assets/images/icon-qwhq-xz.png" />全文获取
                      </div>
                      <div class="achieve" v-if="Resourcelist == item.openAlexId" v-loading="achieveloading" ref="showPanel">
                        <div class="achieve-li">
                          <li v-for="(bookitem, index) in liblist" :key="index" class="1">
                            <a v-safe-html="bookitem.shortName" @click="libdetailUrl(item, bookitem)"></a>
                          </li>
                          <li v-if="gainResource.provideType == '3'" @click="recommendrecord(item)">
                            <a>推荐</a>
                          </li>
                          <li v-if="gainResource.provideType == '2'" @click="getResourceDetail(item, gainResource)">
                            <a>单篇采选</a>
                          </li>
                          <li v-if="gainResource.provideType == '1'" @click="getDeliverSave(item)">
                            <a>文献传递</a>
                          </li>
                          <li v-if="gainResource.provideType == '5'" @click="getLiterature(detail)">
                            <a>请求获取</a>
                          </li>
                          <li v-if="paperData.baiduXueShuExist">
                            <a @click="goBaidu(paperData.baiduXueShuLink)">百度学术</a>
                          </li>
                          <li v-if="qingqiuhuoqu">
                            <a @click="getQingqiu(item)">请求获取</a>
                            <!-- <font><i class="el-icon-info"></i>我们在一天内进行处理，请您稍后重新打开界面获取。</font> -->
                          </li>
                          <!-- <ul v-if="gainResource.provideType == '1'">
                            <li v-for="(wxitem, index) in remmendlist" :key="index">
                              <a v-if="wxitem.name != '文献获取'" v-safe-html="wxitem.name" @click="literatureUrl(wxitem.literatureUrl)"></a>
                              <a v-if="wxitem.name == '文献获取' && item.doi" v-safe-html="wxitem.name" @click="literatureUrl(wxitem.literatureUrl)"></a>
                              <span v-if="wxitem.name == '文献获取'"><i class="el-alert__icon el-icon-warning"></i>一般十分钟获取全文</span>
                              <span v-if="wxitem.name == '百度学术'"><i class="el-alert__icon el-icon-warning"></i>每天免费申请两次</span>
                            </li>
                          </ul> -->
                        </div>
                      </div>
                    </div>
                    <div class="flex" @click="copylist(item.sid)">
                      <img src="../../assets/images/icon-fz-mr.png" class="img" />
                      <img src="../../assets/images/icon-fz.png" class="hover-img" />复制
                    </div>
                    <div class="flex" @click="showReference(item)">
                      <img class="img" src="../../assets/images/icon-yy-mr.png" />
                      <img class="hover-img" src="../../assets/images/icon-yy-xz.png" />引用
                    </div>
                    <div class="flex" :class="{ checked: item.share }" @click="isCollect(item)" v-if="!info.ipUser">
                      <img class="img" :src="item.share ? collectTrue : collectFalse" />
                      <img class="hover-img" src="../../assets/images/icon-sc-xz.png" />收藏
                      <i class="share" v-if="item.shareCount > 0">{{ item.shareCount }}</i>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <div class="noData" v-if="listData.length <= 0">
            <img src="../../assets/images/noData.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 知识图谱 -->
    <div class="page2 atlasCharts" v-if="tabIndex == 2">
      <!-- <iframe :src="userPageUrl" width="100%" height="800" frameborder="0" allowfullscreen></iframe> -->
      <!-- <KnowledgeGraph ref="kg_son" @extendKnowledgeGraph="extendKnowledgeGraph" /> -->
      <KnowledgeGraph ref="kg_son" @extendKnowledgeGraph="extendKnowledgeGraph" @extendOtherMsg="extendOtherMsg">
        <!-- 相关文章扩展插槽 -->
        <div class="info_list" v-show="link_art_list.length > 0">
          <div class="title_info">相关文章</div>
          <ul>
            <li id="link_art" v-for="(item, idx) in link_art_list" :key="idx">
              <p class="title line1" @click="toEnterDetail(item)">
                {{ item.title }}
              </p>
              <p>DOI：{{ item.doi }}</p>
              <p>作者：{{ item.author }}</p>
              <p class="line2">简介：{{ item.abstracts }}</p>
            </li>
          </ul>
        </div>
      </KnowledgeGraph>
    </div>

    <!-- 概念分析 -->
    <div class="page3 w1380" v-show="tabIndex == 3">
      <div class="page3_left" v-loading="loading">
        <ul>
          <li class="page3_left_list flex" v-for="(item, index) in analysisInfoList" :key="index">
            <span>{{ index + 1 }}、</span>
            <div class="page3_flex_right">
              <p class="title">{{ item.title }}</p>
              <p class="content">
                {{ item.content }}
              </p>
              <div class="flex page3_score">
                <div class="score"><img src="../../assets/images/icon-pf.png" />{{ item.rank }}</div>
                <span v-if="!item.listMore" @click="showListMore(index)">详情<i class="el-icon-arrow-down"></i></span>
              </div>
              <ul class="page3_list_list" v-if="item.listMore">
                <li v-for="(element, idx) in item.list" :key="idx">
                  <p class="title">{{ element.title }}</p>
                  <p class="content">
                    {{ element.content }}
                  </p>
                  <div class="page3_list_three" v-for="(loaf, idx) in element.list" :key="idx">
                    <p class="title">{{ loaf.entity }}</p>
                    <p class="content">
                      {{ loaf.description }}
                    </p>
                    <!-- <div class="flex">
                      <div class="flex">
                        <img src="../../assets/images/icon-wz.png" />
                        文章
                      </div>
                      <div class="flex">
                        <img src="../../assets/images/icon-gx.png" />
                        relationship
                      </div>
                      <div class="flex">
                        <img src="../../assets/images/icon-pf.png" />
                        <span>{{ loaf.weight }}</span>
                      </div>
                    </div> -->
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <!-- <div class="btns">
          <el-button type="primary">获取结果</el-button>
        </div> -->
      </div>
      <div class="page3_right">
        <h3>相关文章</h3>
        <ul v-loading="loading">
          <li v-for="(item, index) in analysisPaperList" :key="index">
            <p class="title line1" :title="item.title" @click="toArticleDetail(item)">
              {{ item.title }}
            </p>
            <p class="line1" v-if="item.authorArray && item.authorArray.length > 0">
              作者：<span v-for="(element, index) in item.authorArray" :key="index">
                <span class="span_a" v-safe-html="element"></span>
                <span class="mr5" v-if="index < item.authorArray.length - 1">;</span>
              </span>
            </p>
            <p>DOI：{{ item.doi }}</p>
            <p class="line2">
              摘要：<span>{{ item.abstracts }}</span>
            </p>
          </li>
        </ul>
      </div>
    </div>

    <el-dialog title="引用" :visible.sync="referenceDialog" width="30%">
      <div class="dialog-content">
        <ul class="dialog-tab">
          <li @click="changeDialogTab(1)" :class="{ dialogChecked: dialogIndex == 1 }">BIB</li>
          <li @click="changeDialogTab(2)" :class="{ dialogChecked: dialogIndex == 2 }">CITE</li>
        </ul>
        <div class="tab1" v-if="dialogIndex == 1">
          <ul>
            <li>
              <p class="flex">
                <span @click="copyContent(BIBObj)"> <img src="../../assets/images/icon-fz.png" />复制 </span>
              </p>
              <div class="dialog-info">{{ BIBObj }}</div>
            </li>
          </ul>
        </div>
        <div class="tab1" v-if="dialogIndex == 2">
          <ul>
            <li v-for="(item, index) in CITEArray" :key="index">
              <p class="flex line">
                <label>{{ item.name }}</label>
                <span @click="copyContent(item.value)"> <img src="../../assets/images/icon-fz.png" />复制 </span>
              </p>
              <div class="dialog-info">
                {{ item.value }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        导出为
        <span @click="handleExport('bib')">BibTex</span>
        <span @click="handleExport('endnote')">EndNote</span>
      </span>
    </el-dialog>
    <el-dialog title="绑定手机号" :visible.sync="phoneDialog" width="25%">
      <el-input placeholder="请输入手机号" v-model="phone" maxlength="20" @keyup.enter.native="submitAddphone($event)" class="phone-input"></el-input>
      <div class="flex phone">
        <el-input placeholder="验证码" v-model="code" />
        <span class="code" v-if="show" @click="getCode">发送验证码</span>
        <span class="code" v-else>{{ times }}</span>
      </div>
      <div class="flex phonebtn">
        <el-button @click="phoneDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAddphone">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请求获取文献" :visible.sync="literatureDialogVisible" width="420px" :before-close="handleLiteratureClose">
      <div class="literature-dialog-content">
        <p class="literature-tip-sm">声明：请求的文献仅用于科研与教学使用，不做非法传播、复制</p>
        <p class="literature-tip">请正确输入邮箱，文献请求获取结果会以邮箱方式通知!</p>

        <el-form :model="literatureForm" :rules="literatureRules" ref="literatureFormRef">
          <el-form-item prop="email">
            <el-input v-model="literatureForm.email" placeholder="请输入邮箱地址" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer-right">
        <el-button @click="handleLiteratureClose">取 消</el-button>
        <el-button type="primary" @click="submitLiterature">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KnowledgeGraph from "../../components/KnowledgeGraph.vue";
import baseurl from "../../api/baseurl";
import * as echarts from "echarts";
import Axios from "axios";

export default {
  name: "IntellIndex",
  components: {
    KnowledgeGraph,
  },
  data() {
    return {
      loading: true,
      roles: false,
      entitiesId: "",
      leftData: [],
      leftDataSlice: [],
      listData: [],
      jsonData: {
        nodes: [],
        relationships: [],
      },
      listTotal: 0,
      searchWord: "",
      searchWordResult: "",
      tabIndex: 1,
      collectFalse: require("../../assets/images/icon-sc-mr.png"),
      collectTrue: require("../../assets/images/icon-sc-xz.png"),
      Resourcelist: false,
      gainResource: {},
      leftFlag: false,
      leftNum: 20,
      referenceDialog: false,
      dialogIndex: 1,
      BIBObj: null,
      CITEArray: [],
      node_list: [],
      link_list: [],
      categories: [
        {
          name: "文章",
          itemStyle: {
            color: "#fc853e",
          },
        },
        {
          name: "知识点",
          itemStyle: {
            color: "#28cad8",
          },
        },
      ],
      analysisInfoList: [],
      analysisPaperList: [],
      userPageUrl: "https://jyx.cxstar.cn/knowledge/?word=string",
      link_art_list: [],
      qingqiuhuoqu: false,

      info: "",
      phoneDialog: false,
      show: true,
      phone: "",
      code: "",
      times: 60,
      currentResourceItem: null, // 存储当前资源项

      literatureDialogVisible: false,
      literatureItem: null,
      literatureForm: {
        email: "",
      },
      literatureRules: {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
      },
      paperData: "",
    };
  },
  mounted() {
    if (localStorage.getItem("roles")) {
      let roleArr = localStorage.getItem("roles").split(",");
      roleArr.forEach(element => {
        if (element == "other") {
          this.roles = false;
        }
      });
    }
    if (sessionStorage.getItem("search-keyword")) {
      let searchObj = JSON.parse(sessionStorage.getItem("search-keyword"));
      this.searchWord = searchObj.word;
      this.searchWordResult = searchObj.word;
    }

    //点击空白关闭弹出
    document.addEventListener("click", this.bodyCloseMenus);

    this.getList();
    this.getInfo();
    // this.getEahart();
  },
  destroyed() {},
  methods: {
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.info = res.data;
      });
    },

    // 显示剩余左侧数据
    showAllLeftData() {
      this.leftFlag = true;
    },
    // 收起左侧数据
    closeAllLeftData() {
      this.leftFlag = false;
    },
    handleTab(index) {
      let kg_size = [1380, 800];
      this.tabIndex = index;
      if (this.tabIndex == 1) {
        this.getList();
      }
      if (this.tabIndex == 2) {
        this.$nextTick(() => {
          this.$refs.kg_son.initKnowledgeGrapg(kg_size, this.jsonData);
        });
        // this.getEchartData();
      }
      if (this.tabIndex == 3) {
        this.getAnalysisData();
      }
    },
    toSearch() {
      if (!this.searchWord) {
        this.$message.error("请输入关键词检索");
        return;
      }
      sessionStorage.setItem(
        "search-keyword",
        JSON.stringify({
          word: this.searchWord.trim(),
          paper: "",
          searchType: 2,
        }),
      );
      this.searchWordResult = this.searchWord;
      this.loading = true;
      this.listData = [];
      this.tabIndex = 1;
      this.getList();
    },
    toDetail(item) {
      let _url = this.$router.resolve({
        path: "/articleDetail",
        query: { sid: item.sid },
      });
      window.open(_url.href, "_self");
    },
    toList(item) {
      if (this.entitiesId == item.id) {
        this.entitiesId = "";
      } else {
        this.entitiesId = item.id;
      }

      this.getList();
    },
    getList() {
      let formData = new FormData();
      formData.append("word", this.searchWord);
      formData.append("entitiesId", this.entitiesId);
      this.$http({
        url: `api/v1/resource/ai-search/search`,
        method: "post",
        data: formData,
      }).then(res => {
        if (res.code == 200) {
          this.loading = false;
          this.leftData = res.data.entities;
          if (this.leftData.length > this.leftNum) {
            this.leftDataSlice = res.data.entities.slice(0, this.leftNum);
          } else {
            this.leftDataSlice = this.leftData;
          }
          this.listData = res.data.paperList;
          // 知识图谱数据
          this.jsonData.nodes = this.updateNodes(res.data.nodes);

          this.jsonData.relationships = res.data.relationships;

          this.listData.forEach((element, index) => {
            // 关键词
            if (element.hingeWord) {
              this.$set(this.listData[index], "hingeWordArray", element.hingeWord.split(";"));
            }
            // 作者
            if (element.author) {
              this.$set(this.listData[index], "authorAllArray", element.authorList);
              this.$set(this.listData[index], "authorArray", element.authorAllArray.slice(0, 5));
            }
            // 摘要
            if (element.digest) {
              this.listData[index].digestAll = element.digest.split("<span style='color:red'>").join("").split("</span>").join("");
            }
            // 知识点
            if (element.digest) {
              this.listData[index].digestAll = element.digest.split("<span style='color:red'>").join("").split("</span>").join("");
            }

            element.open = false; //摘要展开收起标识
            element.showauthor = true; //作者展开收起标识
          });
        }
      });
    },
    //作者展开收起
    showauthor(index) {
      this.listData[index].showauthor = false;
      this.listData[index].authorArray = this.listData[index].authorAllArray;
      this.$forceUpdate();
    },
    closeauthor(index) {
      this.listData[index].showauthor = true;
      this.listData[index].authorArray = [];

      for (let i = 0; i < 5; i++) {
        this.listData[index].authorArray.push(this.listData[index].authorList[i]);
      }
      this.$forceUpdate();
    },
    //修改知识图谱数据格式
    updateNodes(data) {
      data.forEach((element, index) => {
        if (element.other_msg) {
          if (element.other_msg.paper_sid) {
            data[index].detail_url = `${window.location.origin}/articleDetail?sid=${element.other_msg.paper_sid}`;
          }
        }
      });
      return data;
    },
    // 展开知识图谱
    extendKnowledgeGraph(cur_node_id) {
      let formData = new FormData();
      // formData.append("artRuId", this.sid);
      formData.append("nodeId", cur_node_id);

      this.$http({
        url: `api/v1/resource/ai-search/knowledgeAtlasSpread`,
        method: "post",
        data: formData,
      }).then(res => {
        if (res.code == 200) {
          let kg_extend_data = res.data;
          this.updateNodes(kg_extend_data.nodes);
          // 调用子组件方法
          this.$refs.kg_son.extendKnowledgeGraph(cur_node_id, kg_extend_data);
        }
      });
    },
    // 获取关联文章
    extendOtherMsg(cur_node_id) {
      this.link_art_list = [];
      // 仅查找实体相关的文章（文章不会关联文章，所以需要过滤掉sources开头的id）
      let entity_flag = "entities";
      if (cur_node_id.indexOf(entity_flag) != -1) {
        this.$http({
          url: `api/v1/resource/ai-search/getWorksTop5ByEntityId?entityId=${cur_node_id}`,
          method: "get",
        }).then(res => {
          if (res.code == 200) {
            this.link_art_list = res.data;
          }
        });
        // // 数据
        // this.$axios
        //   .post("http://192.168.0.14:8014/graph_server/works", {
        //     entity_id_list: [cur_node_id.replace(entity_flag, "").replace("_", "")],
        //   })
        //   .then(res => {
        //     console.log(res.data);
        //     this.link_art_list = res.data.data[0]["source_list"];

        //     // // 调用子组件方法
        //     // this.$refs.kg_son.initKnowledgeGrapg(kg_size, kg_base_data)
        //   });
      }
    },
    toEnterDetail(item) {
      window.open(`${window.location.origin}/articleDetail?sid=${item.sid}`);
    },
    // 收藏
    isCollect(item) {
      let postBody = {
        outSid: item.sid,
        type: 2,
      };
      this.$http({
        url: `api/v1/usershare/collect`,
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          if (res.data == 1) {
            window.location.href = `${baseurl.baseUrl}api/v1/sso/toAuthenticate?redirect=${this.$route.fullPath}`;
          } else {
            if (!item.share) {
              this.$message.success("收藏成功");
            }
            this.getList();
          }
        }
      });
    },
    //获取全文
    getResource(item, index) {
      // 1, “馆藏”
      // 2, “OA”
      // 3, “非馆藏非OA”
      // 5, “采购”
      // 10, “未登录”
      if (this.listData[index].btnLoading) {
        return;
      }
      // if (item.source == "馆外资源") {
      //   this.Resourcelist = false;
      //   this.$message.error("馆外无法获取资源");
      //   this.achieveloading = false;
      //   return;
      // }
      this.listData[index].btnLoading = true;
      this.$forceUpdate();

      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      let postBody = {
        doi: this.detaildoi,
        openAlexId: item.openAlexId,
      };
      this.$http({
        url: "api/v1/wantbuyR/queryPaper",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.data) {
          this.listData[index].btnLoading = false;
          this.$forceUpdate();
          this.paperData = res.data;
          this.qingqiuhuoqu = false;
          this.Resourcelist = false;
          this.gainResource = {};
          this.liblist = [];
          if (res.data.state == 1) {
            this.Resourcelist = res.data.openAlexId;
            this.liblist = res.data.ebookNameList;
            this.achieveloading = false;
          } else if (res.data.state == 2) {
            // 显示请求获取按钮
            this.Resourcelist = res.data.openAlexId;
            this.qingqiuhuoqu = true;
            this.achieveloading = false;
          } else if (res.data.state == 3) {
            this.Resourcelist = res.data.openAlexId;
            this.gainResource = res.data.gainResourceBo;
            if (res.data.gainResourceBo.provideType === 4) {
              this.Resourcelist = false;
              this.$message.error("馆外无法获取资源");
              this.achieveloading = false;
              return;
            }
            this.achieveloading = false;
          } else if (res.data.state == 63) {
            window.open(
              `http://lib.cqu.edu.cn/articlesearch/web_searchingResult?key={"rule":{"ruleBody":"DI=[@DI_79107149_0_f]","ruleParameters":[{"key":"@DI_79107149_0_f","value":"${this.detaildoi}"}]},"filterRule":{"ruleBody":"TY=[@TY_96453382_0_f]","ruleParameters":[{"key":"@TY_96453382_0_f","value":"3"}]}}&keyword=${this.detaildoi}`,
            );
          } else if (res.data.state == 5 || res.data.state == 6 || res.data.state == 7) {
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.applyPaperSourceSid}&type=${res.data.state}`,
              method: "get",
            }).then(downres => {
              if (downres.code == 200) {
                // 采购下载
                if (res.data.state == 5) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/purchase/download?uid=" + downres.data);
                }
                // 文献传递下载
                if (res.data.state == 6) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/deliver/download?uid=" + downres.data);
                }
                // 个人上传文件下载
                if (res.data.state == 7) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/person/download?uid=" + downres.data + "&openAlexId=" + res.data.openAlexId);
                }
              }
            });
          } else if (res.data.state == 10) {
            // this.$router.push({ path: "/lg", query: { word: true } });
            this.$message.warning("该资源的全文仅限用户登录后获取，请先登录");
            //  window.open(`/lg?word=true&isback=true`, "_self");
          } else if (res.data.state == 20) {
            //oa附件  下载附件
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.openAlexId}&type=${res.data.state}`,
              method: "get",
            }).then(res => {
              if (res.code == 200) {
                window.open(baseurl.baseUrl + "api/v1/wantbuyR/oa/download?uid=" + res.data);
              }
            });
          } else if (res.data.state == 52) {
            let title = "";
            let doi = "";
            if (res.data.doi) {
              doi = res.data.doi;
            } else {
              //个别数据会有\n 去除\n
              if (res.data.title.includes("\n")) {
                title = res.data.title.split("\n").join("");
              } else {
                title = res.data.title;
              }
              doi = title;
            }
            let str = '{"query":{"query_string":{"query":"' + doi + '","default_operator":"AND"}},"track_total_hits":true}';
            let query = encodeURIComponent(str);
            window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
          }
        }
      });
    },
    // 馆藏资源跳转
    libdetailUrl(item, bookItem) {
      this.Resourcelist = false;
      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      if (bookItem.shortName == "DOAJ-Directory of Open Access Journals") {
        if (!this.detaildoi) {
          this.detaildoi = item.title;
        }
        let str = '{"query":{"query_string":{"query":"' + this.detaildoi + '","default_operator":"AND"}},"track_total_hits":true}';
        let query = encodeURIComponent(str);
        window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
        return;
      } else {
        this.$http({
          url: "api/v1/wantbuyR/ebook/link?ebookSid=" + bookItem.sid + "&doi=" + this.detaildoi + "&openAlexId=" + item.openAlexId,
          method: "GET",
        }).then(res => {
          if (res.code == 200) {
            window.open(res.data);
          }
        });
      }
    },
    // 文献传递
    getDeliverSave(item, bitem) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/deliver/apply/sys/save?openAlexId=" + item.openAlexId,
        method: "get",
      }).then(res => {
        window.open(`/asp/myDeliver`, "_self");
        // this.$message.success("文献传递成功，请到个人中心我的文献传递中查看~");
      });
    },
    // 文献请求获取 弹出一个弹框输入邮箱
    getLiterature(item) {
      this.Resourcelist = false;
      this.literatureItem = item;
      this.literatureForm.email = "";
      this.literatureDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.literatureFormRef) {
          this.$refs.literatureFormRef.clearValidate();
        }
      });
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (res.code == 200 && res.data && res.data.email) {
          this.literatureForm.email = res.data.email;
        }
      });
    },
    handleLiteratureClose() {
      this.$refs.literatureFormRef.resetFields();
      this.literatureDialogVisible = false;
    },
    submitLiterature() {
      this.$refs.literatureFormRef.validate(valid => {
        if (!valid) return;
        this.literatureDialogVisible = false;
        this.Resourcelist = false;
        this.$http({
          url: "/api/v1/literature-gain-apply/save",
          method: "POST",
          data: {
            paperSid: this.literatureItem.sid,
            email: this.literatureForm.email,
          },
        }).then(res => {
          if (res.code == 200) {
            this.$message.success("请求获取成功，文献获取通知将发送到您的邮箱");
          }
        });
      });
    },
    // 百度学术
    goBaidu(url) {
      window.open(url);
    },
    // 请求获取
    getQingqiu(item) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/literature-gain-apply/save",
        method: "post",
        data: {
          paperSid: item.sid,
        },
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("请求成功，我们将在一天内进行处理，请您稍后在文献服务平台 - 我的申请 - 我的文献申请中获取!");
          this.qingqiuhuoqu = false;
        }
      });
    },
    getResourceDetail(item) {
      this.Resourcelist = false;
      this.currentResourceItem = item;
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (!res.data.phone) {
          this.code = "";
          this.phone = "";
          clearInterval(this.timer);
          this.show = true;
          this.phoneDialog = true;
          return;
        }
        if (item.doi) {
          this.detaildoi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        } else {
          this.detaildoi = "";
        }
        let postBody = {
          doi: this.detaildoi,
          openAlexId: item.openAlexId,
        };
        this.$http({
          url: "/api/v1/promote/wantbuy/getResource",
          method: "POST",
          data: postBody,
        }).then(res => {
          if (res.data.state == 2) {
            this.$message.success("您已提交过申请");
            return;
          }
          if (res.data.state == 3) {
            this.$message.success("订单是否有对应DOI,订购中");
            return;
          }
          if (res.data.state == 4) {
            this.$message.success("供应商暂不提供该资源");
            return;
          }
          if (res.data.state == 5) {
            this.$message.success("符合采选规则,获取成功");
            return;
          }
          // 不符合采选规则,待申请
          if (res.data.state == 6) {
            // 申请
            let dataBody = {
              doi: res.data.doi,
              title: res.data.title,
              paperPrice: res.data.paperPrice,
              singlePrice: res.data.singlePrice,
              totalPrice: res.data.totalPrice,
              badWord: res.data.badWord,
              supplierId: res.data.supplierId,
            };
            this.$http({
              url: "/api/v1/promote/wantbuy/apply",
              method: "POST",
              data: dataBody,
            }).then(respones => {
              this.$message.success(respones.data);
            });

            return;
          }
          if (res.data.state == 8) {
            //已提交过申请
            this.$message.success("资源被图书馆收录");
            return;
          }
          if (res.data.state == 21) {
            //系统繁忙
            this.$message.error("系统繁忙，请稍后重试");

            return;
          }
          if (res.data.state == 22) {
            //资源申请成功
            this.$message.success("资源申请成功，请在个人申请列表中查看");
            return;
          }
        });
      });
    },
    // 引用
    showReference(item) {
      this.dialogIndex = 1;
      this.exportSid = item.sid;
      this.$http({
        url: `api/v1/reception/journalpaper/getReference?sid=${item.sid}`,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.BIBObj = res.data.bib;
          this.CITEArray = [];
          if (res.data.mla) {
            this.CITEArray.push({
              name: "MLA",
              value: res.data.mla,
            });
          }
          if (res.data.apa) {
            this.CITEArray.push({
              name: "APA",
              value: res.data.apa,
            });
          }
          if (res.data.chicago) {
            this.CITEArray.push({
              name: "Chicago",
              value: res.data.chicago,
            });
          }
          if (res.data.gb) {
            this.CITEArray.push({
              name: "GB",
              value: res.data.gb,
            });
          }
          this.referenceDialog = true;
        }
      });
    },
    //推荐
    recommendrecord(item) {
      this.Resourcelist = false;
      this.$http({
        url: "api/v1/advice/record/save/sys?openAlexId=" + item.openAlexId,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("推荐成功");
        } else {
          this.$message.error("推荐失败");
        }
      });
    },
    // 复制
    copyContent(val) {
      this.$copyText(val).then(
        () => {
          this.$message.success("复制成功");
          // 复制成功的操作
        },
        () => {
          this.$message.error("复制失败");
          // 复制失败的操作
        },
      );
    },
    // 导出
    handleExport(type) {
      let url = "";
      if (type == "bib") {
        url = baseurl.baseUrl + "/api/v1/reception/journalpaper/exportBibTexReference?sid=" + this.exportSid;
      } else {
        url = baseurl.baseUrl + "/api/v1/reception/journalpaper/exportEndNoteReference?sid=" + this.exportSid;
      }
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: localStorage.getItem("jyx_token"),
        },
        url,
      };

      Axios(options).then(res => {
        let blob = new Blob([res.data]);
        let objectUrl = URL.createObjectURL(blob); //创建下载的链接
        let a = document.createElement("a");
        a.href = objectUrl;

        // 获取文件名
        let fileName = type == "bib" ? "publication.bib" : "publication.enw";
        fileName = decodeURI(fileName);
        a.download = fileName; //设置文件名
        //下面这个写法兼容火狐
        a.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          }),
        );
        window.URL.revokeObjectURL(blob); //释放bolb对象
      });
    },
    changeDialogTab(index) {
      this.dialogIndex = index;
    },

    bodyCloseMenus(e) {
      // 获取全文里的弹框
      if (this.Resourcelist) {
        this.Resourcelist = false;
      }
    },
    beforeDestroy() {
      document.removeEventListener("click", this.bodyCloseMenus);
    },
    // 获取概念分析 数据
    getAnalysisData() {
      let formData = new FormData();
      formData.append("word", this.searchWord);
      this.loading = true;
      this.$http({
        url: `api/v1/resource/ai-search/conceptualAnalysis`,
        method: "post",
        data: formData,
      }).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.analysisInfoList = res.data.infoList;
          this.analysisInfoList.forEach(element => {
            element.listMore = false;
          });
          this.analysisPaperList = res.data.paperList;

          this.analysisPaperList.forEach((element, index) => {
            if (element.author) {
              this.$set(this.analysisPaperList[index], "authorArray", element.author.split(";"));
            }
          });
        }
      });
    },
    // 展开列表详情
    showListMore(index) {
      this.analysisInfoList.forEach(element => {
        element.listMore = false;
      });
      this.analysisInfoList[index].listMore = true;
      this.$forceUpdate();
    },
    // 文章跳转
    toArticleDetail(item) {
      let _url = this.$router.resolve({
        path: "/articleDetail",
        query: { sid: item.sid },
      });
      window.open(_url.href, "_self");
    },
    // 期刊信息跳转
    toHomeDetail(item) {
      let _url = this.$router.resolve({
        path: "homeDetail",
        query: { sid: item.journalSid },
      });
      window.open(_url.href, "_self");
    },
    // 关键词检索
    searchWords(item) {
      let val = item.split("<span style='color:red'>").join("").split("</span>").join("");
      this.searchWord = val;
      this.searchWordResult = val;

      sessionStorage.setItem(
        "search-keyword",
        JSON.stringify({
          word: this.searchWord.trim(),
          paper: "",
          searchType: 2,
        }),
      );
      this.loading = true;
      this.listData = [];
      this.tabIndex = 1;
      this.getList();
    },
    // 作者详情跳转
    toAuthorDetail(item) {
      if (item.click) {
        let _url = this.$router.resolve({
          path: "/authorDetail",
          query: { authorSid: item.sid },
        });
        window.open(_url.href, "_self");
      }
    },
    //复制引文
    copylist(id) {
      // 根据当前引文格式获取选中内容
      this.$http({
        url: "api/v1/wantbuyR/copy/context?sid=" + id,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          let copydata = res.data;
          try {
            navigator.clipboard.writeText(copydata).then(() => {
              this.$message.success("已复制,您可随意粘贴使用");
            });
          } catch (err) {
            // 兼容旧浏览器的复制方式
            const textarea = document.createElement("textarea");
            textarea.value = copydata;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            this.$message.success("已复制,您可随意粘贴使用");
          }
        }
      });
    },
    getCode() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      this.$http({
        url: `api/v1/tourist/check/repeat/mobile?mobile=${this.phone}`,
        method: "get",
      }).then(res => {
        if (res.data) {
          this.times = 60;
          let formData = new FormData();
          formData.append("mobilePhone", this.phone);

          this.$http({
            url: `api/v1/user/sendCode`,
            method: "POST",
            data: formData,
          }).then(res => {
            this.show = false;
            this.timer = setInterval(() => {
              this.times--;
              if (this.times === 0) {
                this.show = true;
                clearInterval(this.timer);
              }
            }, 1000);
          });
        } else {
          this.$message.error("该手机号已存在");
          return;
        }
      });
    },
    submitAddphone() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      if (!this.code.trim()) {
        this.$message.error("请输入验证码");
        return;
      }
      let formData = new FormData();
      formData.append("newMobile", this.phone);
      formData.append("smsCode", this.code);
      this.$http({
        url: `api/v1/user/changephone`,
        method: "POST",
        data: formData,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.phoneDialog = false;
          // 绑定成功后自动再次调用getResourceDetail方法
          if (this.currentResourceItem) {
            this.getResourceDetail(this.currentResourceItem);
          }
        }
      });
    },
    // 在组件销毁前清除定时器
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 154px);
  .w1380 {
    width: 1380px;
    margin: 0 auto;
  }
  .top_search {
    height: 250px;
    width: 100%;
    background: #fff;
    background: url("../../assets/images/bj.png") no-repeat #fff center;
    display: flex;
    align-items: center;
    justify-content: center;
    .top_bg {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      .top-textarea {
        // background: url("../../assets/images/znjs-kuang.png") no-repeat;
        width: 968px;

        ::v-deep .el-textarea__inner {
          // border: none;
          // background: none;
          // height: 190px;
          font-size: 16px;
          color: #666;
          resize: none;
        }
        // ::v-deep .el-input__count {
        //   background: none;
        // }
      }
      .el-button {
        margin-left: 15px;
        width: 90px;
        height: 46px;
        border-radius: 0;
        font-size: 18px;
      }
    }
  }
  .tab {
    background: linear-gradient(0deg, #fafafa 0%, rgba(98, 215, 216, 0.3) 100%), #ffffff;
    width: 1380px;
    margin: 20px auto;
    ul {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      li {
        margin: 0 20px;
        cursor: pointer;
      }
      .checked {
        color: #2d8cf0;
        position: relative;
        &::after {
          position: absolute;
          content: "";
          width: 100%;
          height: 2px;
          background: #2d8cf0;
          left: 0;
          bottom: -12px;
        }
      }
    }
  }
  .page1 {
    align-items: baseline;

    .left {
      width: 250px;

      position: relative;
      padding: 0 25px;
      background: #fff;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: linear-gradient(90deg, #006eb3, #2d8cf0) #2d8cf0;
      }
      p {
        height: 50px;
        line-height: 50px;
        align-items: center;
        i {
          margin-left: auto;
          font-size: 20px;
          color: #666;
          cursor: pointer;
        }
      }
      ul {
        border-top: 1px solid #e6e6e6;
        padding: 15px 0;
        min-height: 400px;
        .checked {
          color: #2d8cf0;
        }
        li {
          font-size: 14px;
          display: flex;
          margin-bottom: 10px;
          cursor: pointer;
          &:last-of-type {
            margin: 0;
          }
          span {
            display: inline-block;
            width: 70%;
          }
          i {
            font-style: normal;
            color: #999999;
            margin-left: auto;
          }
        }
      }
    }
    .right-list {
      flex: 1;
      margin-left: 20px;
      min-width: 0;

      .right-top {
        background: #fff;
        .filter {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          padding: 13px 15px;
          line-height: 30px;
          .red {
            color: #ff0000;
          }
        }
      }
    }
    .right-item {
      background: #fff;
      margin-top: 10px;
      min-height: 400px;
      ul {
        padding: 0 20px;

        li {
          padding: 20px 0;
          border-bottom: 1px dashed #eeeeee;
          .index {
            width: 50px;
            line-height: 30px;
          }
          .right-info {
            color: #666666;
            flex: 1;
            min-width: 0;
            .knowledge {
              font {
                color: #666;
              }
              span {
                position: relative;
              }
              .more {
                cursor: pointer;
                color: #2d8cf0;
              }
            }
            .green {
              &:hover {
              }
            }
            .mr5 {
              margin-right: 5px;
            }
            .active {
              display: inline-block;
              white-space: nowrap;
              width: 90%;
              overflow: hidden;
              text-overflow: ellipsis;
              vertical-align: bottom;
            }
            .undline {
              color: #2d8cf0;
              cursor: pointer;
              &:hover {
                text-decoration: underline;
              }
            }
            .btn {
              display: flex;
              align-items: center;
            }
            > p {
              line-height: 30px;
              .fenhao {
                cursor: pointer;
                &:hover {
                  text-decoration: underline;
                }
                label {
                  cursor: pointer;
                  &:last-of-type {
                    margin: 0 5px;
                  }
                }
              }
              &:nth-of-type(1) {
                color: #333;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 10px;
                cursor: pointer;
                label {
                  font-size: 14px;
                  padding-left: 5px;
                  width: 60px;
                  line-height: 22px;
                  text-align: center;
                  color: white;
                  font-weight: initial;
                  padding: 2px 5px;
                  margin-left: 5px;
                }
              }
              .digestLabel {
                cursor: pointer;
                margin-left: 10px;
                &:hover {
                  color: #2d8cf0;
                }
              }
            }
            .span-content {
              position: relative;
              .author-content {
                top: 30px;
                left: 0px;
              }
            }
            .green_span {
              cursor: pointer;
              &:hover {
                .span_a {
                  text-decoration: underline;
                }
                transition: all 1s;
                .author-content {
                  display: inline-block;
                }
              }
              .span_a {
                color: #2d8cf0;
              }
            }
            .author-content {
              position: absolute;
              background: #fff;
              box-shadow: 0 0 5px #d3d3d3;
              display: none;
              padding: 10px;
              z-index: 9999;
              top: -30px;
              right: -210px;
              min-width: 300px;
              .mb10 {
                font-size: 16px;
                margin-bottom: 10px !important;
              }
              .hui {
                margin-top: 5px !important;
                white-space: pre-wrap;
              }
              p {
                font-size: 14px;
                margin: 0 !important;
                line-height: 20px;
                span {
                  position: relative;
                  &:first-of-type {
                    margin-right: 14px;
                    &::before {
                      content: "";
                      position: absolute;
                      width: 1px;
                      height: 14px;
                      background: #ccc;
                      right: -7px;
                      top: 50%;
                      margin-top: -7px;
                    }
                  }
                  label {
                    color: #2d8cf0;
                  }
                }
              }
            }
            .btn-p {
              align-items: end;
              margin-top: 25px;
              .num-tips {
                span {
                  // color: #2d8cf0;
                  margin-left: 5px;
                }
              }
              .share {
                font-style: normal;
                color: #2d8cf0;
                margin-left: 5px;
              }
            }
            .btn-right {
              margin-left: auto;
              display: flex;
              align-items: center;
              .rotating-image {
                animation: rotate 1s linear infinite;
              }
              @keyframes rotate {
                from {
                  transform: rotate(0deg);
                }
                to {
                  transform: rotate(360deg);
                }
              }
              img {
                margin-top: 2px;
                margin-right: 5px;
              }
              .checked {
                color: #2d8cf0;
              }
              .noCourse {
                cursor: default !important;
              }
              .flex {
                align-items: center;
                margin-left: 30px;
                cursor: pointer;
                position: relative;
                &:hover {
                  color: #2d8cf0;
                  text-decoration: underline;
                  .hover-img {
                    display: inline-block;
                  }
                  .img {
                    display: none;
                  }
                }

                .hover-img {
                  display: none;
                }
              }
            }
          }
          &:hover {
            .right-info {
              > p {
                &:nth-of-type(1) {
                  background-image: linear-gradient(to right, #006eb3, #2d8cf0);
                  background-clip: text;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  label {
                    -webkit-text-fill-color: initial;
                  }
                }
              }
            }
          }

          .achieve {
            background: #ffffff;
            border-radius: 2px;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
            position: absolute;
            top: 35px;
            right: 0;
            z-index: 99999;
            cursor: text;

            &::after {
              content: "";
              position: absolute;
              top: -6px;
              right: 10px;
              width: 0;
              height: 0;
              border-left: 8px solid transparent;
              border-right: 8px solid transparent;
              border-bottom: 10px solid #fff; /* 三角形的颜色 */
            }
            .achieve-li {
              min-width: 270px;
              max-width: 700px;
              overflow-y: auto;
              max-height: 200px;
              padding: 15px 20px;
            }

            li {
              font-size: 16px;
              line-height: 28px;
              padding: 0px;
              border-bottom: 0px;
              a {
                text-decoration: underline;
                color: #2d8cf0;
                cursor: pointer;
              }
              span {
                font-size: 14px;
                color: #b3b3b3;
                margin-left: 5px;
              }
              font {
                color: #b3b3b3;
                font-size: 12px;
                display: block;
                line-height: 20px;
                i {
                  margin-right: 5px;
                  color: #e6a23c;
                }
              }
              .el-icon-warning {
                color: #e6a23c;
                padding: 0px 10px;
                width: 30px;
              }
            }
          }
          ::-webkit-scrollbar {
            display: block;
            width: 3px; /* 定制滚动条的宽度 */
          }
          /* 定制滚动条滑块样式 */
          ::-webkit-scrollbar-thumb {
            background-color: #2d8cf0;
          }
          ::-webkit-scrollbar-track {
            background-color: #f2f2f2; /* 设置滑块以外区域的背景颜色 */
          }
        }
      }
    }
  }
  .page2 {
    background: #fff;
    width: 1380px;
    margin: 0 auto;
    min-height: calc(100vh - 600px);
    margin-bottom: 20px;
    .title_info {
      margin-bottom: 10px;
      font-weight: bold;
    }
    .info_list {
      li {
        margin-bottom: 10px;
        .title {
          font-weight: bold;
          position: relative;
          padding-left: 15px;
          margin-bottom: 5px;
          margin-top: 0;
          cursor: pointer;
          color: #333;
          &:hover {
            color: #2d8cf0;
            cursor: pointer;
          }
          &::after {
            content: "";
            width: 6px;
            height: 6px;
            background: #2d8cf0;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -3px;
          }
        }
        p {
          margin-top: 5px;
          color: #666;
        }
      }
    }
  }
  .page3 {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    .page3_left {
      background: #fff;
      width: 860px;
      margin-right: 20px;
      color: #666;
      position: relative;
      min-height: 400px;
      > ul {
        padding: 20px;
      }
      .btns {
        display: none;
        position: fixed;
        bottom: 105px;
        background: #fff;
        width: 860px;
        height: 76px;
        line-height: 76px;
        text-align: right;
        padding-right: 40px;
        .el-button {
          border-radius: 0;
          width: 124px;
          height: 46px;
          font-size: 18px;
        }
      }

      .page3_left_list {
        margin-bottom: 20px;
        border-bottom: 1px dashed #e6e6e6;
        &:last-of-type {
          margin: 0;
          border: none;
        }
      }
      .page3_flex_right {
        > .title {
          font-size: 18px;
          color: #333;
          font-weight: bold;
          margin-bottom: 10px;
        }
        > .content {
          line-height: 25px;
        }
        .page3_score {
          margin: 15px 0;
          margin-bottom: 20px;
          .score {
            display: flex;
            align-items: center;
            color: #ffb400;
            img {
              margin-right: 5px;
            }
          }
          span {
            cursor: pointer;
            margin-left: auto;
            color: #2d8cf0;
            i {
              margin-left: 5px;
            }
          }
        }
        .page3_list_list {
          li {
            background: #f0f7f7;
            padding: 20px;
            margin-bottom: 20px;

            .title {
              font-size: 16px;
              color: #333;
              font-weight: bold;
              margin-bottom: 10px;
            }
            > .content {
              line-height: 25px;
            }
            .page3_list_three {
              background: #fff;
              padding: 20px;
              margin-top: 20px;
              > .content {
                font-size: 14px;
                line-height: 25px;
              }
              > .flex {
                margin-top: 20px;
                font-size: 14px;
                .flex {
                  align-items: center;
                  margin-right: 30px;
                  cursor: pointer;
                  img {
                    margin-right: 5px;
                  }
                  span {
                    color: #ffb400;
                  }
                }
              }
            }
          }
        }
      }
    }
    .page3_right {
      background: #fff;
      flex: 1;
      position: relative;
      min-width: 0;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: linear-gradient(90deg, #006eb3, #2d8cf0) #2d8cf0;
      }
      h3 {
        width: 200px;
        height: 46px;
        line-height: 46px;
        padding-left: 30px;
        background: #edfafa;
        font-size: 16px;
        margin-top: 20px;
        margin-bottom: 30px;
      }
      ul {
        padding: 0px 20px;
        min-height: 400px;
        li {
          color: #666666;
          margin-bottom: 20px;
          .title {
            color: #333;
            font-weight: bold;
            position: relative;
            padding-left: 20px;
            line-height: normal;
            cursor: pointer;
            &::after {
              content: "";
              position: absolute;
              width: 6px;
              height: 6px;
              background: #2d8cf0;
              left: 0;
              top: 50%;
              margin-top: -3px;
            }
          }
          p {
            padding-left: 20px;
            line-height: 30px;
            .green {
              color: #2d8cf0;
            }
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: left;
    padding-top: 0;
    padding-bottom: 30px;
    .dialog-footer {
      span {
        width: 80px;
        height: 30px;
        display: inline-block;
        text-align: center;
        line-height: 30px;
        margin-left: 10px;
        cursor: pointer;
        background: #f0f7f7;
        color: #2d8cf0;
        &:hover {
          background: #2d8cf0;
          color: #fff;
        }
      }
    }
  }
  .dialog-content {
    .dialog-tab {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #333;
      border-bottom: 1px solid #e6e6e6;
      li {
        padding-right: 10px;
        position: relative;
        padding: 0 10px;
        padding-bottom: 5px;
        cursor: pointer;
      }
      .dialogChecked {
        color: #2d8cf0;
        &::before {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          height: 2px;
          background: #2d8cf0;
          width: 100%;
        }
      }
    }
    .tab1 {
      margin-top: 20px;
      ul {
        max-height: 500px;
        overflow: auto;
        li {
          background: #f7f7f7;
          padding: 30px;
          margin-bottom: 10px;
          &:last-of-type {
            margin: 0;
          }
        }
      }
      ::-webkit-scrollbar {
        display: block;
        width: 8px; /* 定制滚动条的宽度 */
      }
      /* 定制滚动条滑块样式 */
      ::-webkit-scrollbar-thumb {
        background-color: #d9d9d9;
      }
      ::-webkit-scrollbar-track {
        background-color: #f2f2f2; /* 设置滑块以外区域的背景颜色 */
      }

      .flex {
        align-items: center;

        span {
          margin-left: auto;
          cursor: pointer;
          display: flex;
          align-items: center;
          color: #2d8cf0;
        }
      }
      .line {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;
        label {
          color: #333;
          font-weight: bold;
        }
      }
      img {
        width: 17px;
        height: 16px;
        margin-right: 5px;
      }
      .dialog-info {
        color: #333333;
        line-height: 30px;
        margin-top: 20px;
        font-size: 16px;
        white-space: pre-wrap;
      }
    }
  }
}
</style>
<style>
.el-tooltip__popper.is-light {
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
  border: none;
  color: #666666;
  max-width: 800px;
}
.el-tooltip__popper.is-light .popper__arrow {
  display: none;
}
.el-tooltip__popper.is-light .popper__arrow::after {
  display: none;
}
</style>
<style lang="scss">
.tool_box {
  color: #333;
  .tool_site {
    span {
      color: #2d8cf0;
    }
  }
  .tool_click {
    color: #2d8cf0;
    cursor: pointer;
  }
}
::v-deep .el-dialog__body {
  padding: 20px 20px 50px 20px;
}
.phone {
  margin: 20px 0px;
  ::v-deep .el-input {
    .el-input__inner {
      padding-right: 120px;
    }
  }
  align-items: center;
  position: relative;
  .code {
    position: absolute;
    right: 15px;
    padding: 0 20px;
    color: #2d8cf0;
    top: 0;
    line-height: 38px;
    cursor: pointer;
    &::after {
      position: absolute;
      left: 0;
      width: 1px;
      height: 20px;
      background: #c9ebf7;
      content: "";
      top: 10px;
    }
  }
}
.phonebtn {
  display: flex;
  justify-content: flex-end;
}
.el-dialog__footer .dialog-footer-right {
  text-align: right;
  display: block;
}
.literature-dialog-content {
  .literature-tip {
    color: #333;
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 1.6;
  }
  .literature-tip-sm {
    font-size: 12px;
    margin-bottom: 20px;
    color: #ff0000;
  }
}
</style>
